import { useDimension } from "@/shared/store/dimensions-store"
import { DotLottiePlayer } from "@dotlottie/react-player"
import { useTranslation } from "react-i18next"

interface LoadingProps {
  state?: string
}

export default function GameLoading({ state }: LoadingProps) {
  const isDark = useDimension((state) => state.isDark)
  const { t } = useTranslation("Loading")
  if (isDark === undefined) return
  return (
    <>
      <div className="bg-background z-[65] flex fixed top-0 left-0 w-full h-screen flex-col items-center justify-center">
        <DotLottiePlayer
          style={{ height: 145, width: 200 }}
          src={`/animations/loader-${isDark ? "dark" : "light"}.json`}
          renderer="svg"
          autoplay
          loop
          className=""
        />
        <div className="text-primary mb-20 flex items-center justify-center font-medium">
          <p>
            {state ? state : t("connect")}
            <span className="ml-[3px] inline-flex gap-[2px]">
              <span className="dot">.</span>
              <span className="dot">.</span>
              <span className="dot">.</span>
            </span>
          </p>
        </div>
      </div>
    </>
  )
}
